<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Statystyki montaży</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Statystyki montaży</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight logs">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span class="ibox-toggle">
              <i :class="chevronFiltersClass"></i>
            </span>
          </div>
          <div class="ibox-content flex" v-show="isFiltersOpen">
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Wybierz daty</label>
                <div class="col-sm-8">
                  <VueDatePicker
                    class="stats-daterangepicker2"
                    v-model="filterRangeDate"
                    multi-calendars
                    :format="formatRange"
                    range
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isStatsOpen = !isStatsOpen">
            <h5>Statystyki</h5>
            <span class="ibox-toggle">
              <i :class="chevronStatsClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isStatsOpen">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "MontagelogsList",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const store = useStore();
    const montageStatsData = computed(() => store.getters.getMontageStatsData);
    let headers = [
      { text: "ID", value: "pk" },
      { text: "Użytkownik", value: "name", sortable: true, search: true },
      {
        text: "Zamkniętych",
        value: "closed",
        sortable: true,
      },
      { text: "Zmontowanych", value: "mounted" },
      { text: "Wydruk.", value: "printed" },
      { text: "Wydruk. (8)", value: "printed_8_plates" },
      { text: "Wydruk. (4)", value: "printed_4_plates" },
      { text: "Wydruk. (4 + odwrotka)", value: "printed_4_plates_flipped" },
      { text: "Nakład wydrukowanych [szt.]", value: "printed_quantity" },
      { text: "Waga wydrukowanych [kg.]", value: "printed_weight" },
      { text: "Naśw. płyt", value: "radiated" },
      { text: "Naśw. płyt (8)", value: "radiated_8_plates" },
      { text: "Naśw. płyt (4)", value: "radiated_4_plates" },
      { text: "Naśw. płyt (4 + odwrotka)", value: "radiated_4_plates_flipped" },
    ];
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const filtersMonth = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
      sortBy: "name",
      sortType: "desc",
    });
    let items = ref([]);
    let itemsAll = ref(0);
    const filterRangeDate = ref();
    const isFiltersOpen = ref(true);
    const isStatsOpen = ref(true);
    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa-chevron-up" : "fa-chevron-down"
    );
    const chevronStatsClass = computed(() =>
      isStatsOpen.value ? "fa-chevron-up" : "fa-chevron-down"
    );

    const getMontageStats = () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      store.dispatch("getMontageStats", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
      });
    };

    const formatRange = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getMontageStats();
          isSearch.value = false;
        }, 1000);
      }
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = [];
      serverOptions.value.sortBy = "";
      getMontageStats();
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("smontageSearchValue") !== null) {
        searchValue.value = localStorage.getItem("smontageSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (
        localStorage.getItem("smontageRangeDate") !== null &&
        localStorage.getItem("smontageRangeDate") !== undefined
      ) {
        filterRangeDate.value = localStorage.getItem("smontageRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }
      getMontageStats();
    });

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "smontageSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "smontageRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getMontageStats();
      }
    );

    watch(
      () => montageStatsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        getMontageStats();
      }
    );
    watch(
      () => filtersMonth.value,
      function () {
        getMontageStats();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getMontageStats();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      serverOptions,
      items,
      itemsAll,
      loading,
      formatRange,
      searchValue,
      search,
      updateSort,
      isSearch,
      rowsPerPage,
      filtersMonth,
      selectPage,
      setRowsPerPage,
      resetFilters,
      filterRangeDate,
      isFiltersOpen,
      isStatsOpen,
      chevronFiltersClass,
      chevronStatsClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.ibox-toggle:hover {
  color: #333;
}
</style>
